let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iRKhU")).then(() => parcelRequire('j6Zgo'));